<script>
import Form, { formCreate } from '../../../../../../components/form';
import request from '../../../../../../utils/request.js';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'main_form',
    };
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'num') { // 数量
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
          controls: false,
        };
      }
      if (v.field === 'amount') { // 金额
        v.props = {
          ...v.props,
          min: 0,
          precision: 2,
          controls: false,
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        this.getDetail();
      }
    },
    /** @desc 设置详情的value值 */
    getDetail() {
      const params = {
        id: this.formConfig.id,
      };
      const requestUrl = '/cps/paymentRecord/findById';
      request.get(requestUrl, params).then((res) => {
        if (res.success) {
          this.setValue({
            ...res.result,
            photoList: (res.result.photoList || []).map((el) => el.url), // 图片limit为1,要取链接
          });
        }
      });
    },
  },
};
</script>
